module.exports = {
    BASE_URL: BASE_URL,
    auth: BASE_URL + "auth/",
    authCheck: BASE_URL + "authcheck/",
    authLogout: BASE_URL + "authlogout/",
    authGetPermissions: BASE_URL + "authgetpermissions/",
    informes: BASE_URL + "informes/",
    misc: {
        pictureUploadURL : BASE_URL + "misc/Image/",
        paises: {
            list: BASE_URL + "misc/pais/list/",
            select: BASE_URL + "misc/pais/select/",
            create: BASE_URL + "misc/pais/create/",
            edit: BASE_URL + "misc/pais/edit/",
            detail: BASE_URL + "misc/pais/detail/",
            delete: BASE_URL + "misc/pais/delete/",
            export: BASE_URL + "misc/pais/export/",
        }
    },
    usuarios: {
        usuarios: {
            list: BASE_URL + "usuarios/list/",
            select: BASE_URL + "usuarios/select/",
            create: BASE_URL + "usuarios/create/",
            edit: BASE_URL + "usuarios/edit/",
            detail: BASE_URL + "usuarios/detail/",
            delete: BASE_URL + "usuarios/delete/",
            export: BASE_URL + "usuarios/export/",

            permisos: BASE_URL + "usuarios/permisos/",

            lock: BASE_URL + "usuarios/lock/",
            unlock: BASE_URL + "usuarios/unlock/",

            perfil: BASE_URL + "usuarios/perfil/",

        },
        permisos: {
            list: BASE_URL + "usuarios/permisos/list/",
            select: BASE_URL + "usuarios/permisos/select/",
            treeselect: BASE_URL + "usuarios/permisos/treeselect/",
            create: BASE_URL + "usuarios/permisos/create/",
            edit: BASE_URL + "usuarios/permisos/edit/",
            delete: BASE_URL + "usuarios/permisos/delete/",
            export: BASE_URL + "usuarios/permisos/export/",
        },
        perfiles: {
            list: BASE_URL + "usuarios/perfiles/list/",
            select: BASE_URL + "usuarios/perfiles/select/",
            create: BASE_URL + "usuarios/perfiles/create/",
            edit: BASE_URL + "usuarios/perfiles/edit/",
            detail: BASE_URL + "usuarios/perfiles/detail/",
            delete: BASE_URL + "usuarios/perfiles/delete/",
            export: BASE_URL + "usuarios/perfiles/export/",
        },
        grupos: {
            list: BASE_URL + "usuarios/grupos/list/",
            select: BASE_URL + "usuarios/grupos/select/",
            create: BASE_URL + "usuarios/grupos/create/",
            edit: BASE_URL + "usuarios/grupos/edit/",
            detail: BASE_URL + "usuarios/grupos/detail/",
            delete: BASE_URL + "usuarios/grupos/delete/",
            export: BASE_URL + "usuarios/grupos/export/",
        },
        subgrupos: {
            list: BASE_URL + "usuarios/subgrupos/list/",
            select: BASE_URL + "usuarios/subgrupos/select/",
            create: BASE_URL + "usuarios/subgrupos/create/",
            edit: BASE_URL + "usuarios/subgrupos/edit/",
            detail: BASE_URL + "usuarios/subgrupos/detail/",
            delete: BASE_URL + "usuarios/subgrupos/delete/",
            export: BASE_URL + "usuarios/subgrupos/export/",
        },
        personal: {
            list: BASE_URL + "usuarios/personal/list/",
            select: BASE_URL + "usuarios/personal/select/",
            create: BASE_URL + "usuarios/personal/create/",
            edit: BASE_URL + "usuarios/personal/edit/",
            detail: BASE_URL + "usuarios/personal/detail/",
            delete: BASE_URL + "usuarios/personal/delete/",
            export: BASE_URL + "usuarios/personal/export/",
        }
    },
    clientes: {
        clasificacion: {
            list: BASE_URL + "clientes/clasificacionempresa/list/",
            select: BASE_URL + "clientes/clasificacionempresa/select/",
            create: BASE_URL + "clientes/clasificacionempresa/create/",
            edit: BASE_URL + "clientes/clasificacionempresa/edit/",
            delete: BASE_URL + "clientes/clasificacionempresa/delete/",
            export: BASE_URL + "clientes/clasificacionempresa/export/",
        },
        rubros: {
            list: BASE_URL + "clientes/rubros/list/",
            select: BASE_URL + "clientes/rubros/select/",
            create: BASE_URL + "clientes/rubros/create/",
            edit: BASE_URL + "clientes/rubros/edit/",
            delete: BASE_URL + "clientes/rubros/delete/",
            export: BASE_URL + "clientes/rubros/export/",
        },
        empresas: {
            list: BASE_URL + "clientes/empresas/list/",
            select: BASE_URL + "clientes/empresas/select/",
            create: BASE_URL + "clientes/empresas/create/",
            edit: BASE_URL + "clientes/empresas/edit/",
            detail: BASE_URL + "clientes/empresas/detail/",
            delete: BASE_URL + "clientes/empresas/delete/",
            export: BASE_URL + "clientes/empresas/export/",
        },
        responsables: {
            list: BASE_URL + "clientes/responsables/list/",
            select: BASE_URL + "clientes/responsables/select/",
            create: BASE_URL + "clientes/responsables/create/",
            edit: BASE_URL + "clientes/responsables/edit/",
            delete: BASE_URL + "clientes/responsables/delete/",
            export: BASE_URL + "clientes/responsables/export/",
        },
        tiporesponsables: {
            select: BASE_URL + "clientes/tiporesponsables/select/",
        },
    },
    proyectos: {
        contactos: {
            list: BASE_URL + "proyectos/contactos/list/",
            select: BASE_URL + "proyectos/contactos/select/",
            create: BASE_URL + "proyectos/contactos/create/",
            edit: BASE_URL + "proyectos/contactos/edit/",
            detail: BASE_URL + "proyectos/contactos/detail/",
            delete: BASE_URL + "proyectos/contactos/delete/",
            export: BASE_URL + "proyectos/contactos/export/",
        },
        solicitudes: {
            list: BASE_URL + "proyectos/solicitudes/list/",
            listhitoricos: BASE_URL + "proyectos/solicitudes/listhitoricos/",
            select: BASE_URL + "proyectos/solicitudes/select/",
            selectcodigo: BASE_URL + "proyectos/solicitudes/selectcodigo/",

            getnumero: BASE_URL + "proyectos/solicitudes/getnumero/",

            create: BASE_URL + "proyectos/solicitudes/create/",
            edit: BASE_URL + "proyectos/solicitudes/edit/",
            desestimar: BASE_URL + "proyectos/solicitudes/desestimar/",
            detail: BASE_URL + "proyectos/solicitudes/detail/",
            delete: BASE_URL + "proyectos/solicitudes/delete/",
            export: BASE_URL + "proyectos/solicitudes/export/",

            history: BASE_URL + "proyectos/solicitudes/history/",
            visualizadorglobal: BASE_URL + "proyectos/solicitudes/visualizadorglobal/",
            estadisticas: BASE_URL + "proyectos/solicitudes/estadisticas/",

            asignar: BASE_URL + "proyectos/solicitudes/asignar/",
            avanzar: BASE_URL + "proyectos/solicitudes/avanzar/",

            certificado: BASE_URL + "certificacion/solicitudes/certificado/",

            cambiarahistorico: BASE_URL + "proyectos/solicitudes/cambiarahistorico/",
            habilitarhistoricos: BASE_URL + "proyectos/solicitudes/habilitarhistoricos/",
        },
        plandetrabajo: {
            list: BASE_URL + "proyectos/plandetrabajo/list/",
            listhitoricos: BASE_URL + "proyectos/plandetrabajo/listhitoricos/",
            select: BASE_URL + "proyectos/plandetrabajo/select/",
            edit: BASE_URL + "proyectos/plandetrabajo/edit/",
            detail: BASE_URL + "proyectos/plandetrabajo/detail/",
            export: BASE_URL + "proyectos/plandetrabajo/export/",
            avanzar: BASE_URL + "proyectos/plandetrabajo/avanzar/",
            subirdocumento: BASE_URL + "proyectos/plandetrabajo/subirdocumento/",
            generardoc: BASE_URL + "proyectos/plandetrabajo/generardoc/",
            downloaddoc: BASE_URL + "proyectos/plandetrabajo/downloaddoc/",
        },
        presupuesto: {
            list: BASE_URL + "proyectos/presupuesto/list/",
            listagrupados: BASE_URL + "proyectos/presupuesto/listagrupados/",
            listhitoricos: BASE_URL + "proyectos/presupuesto/listhistoricos/",
            select: BASE_URL + "proyectos/presupuesto/select/",
            edit: BASE_URL + "proyectos/presupuesto/edit/",
            detail: BASE_URL + "proyectos/presupuesto/detail/",
            CargarPresupuestoFormal: BASE_URL + "proyectos/presupuesto/cargarpresupuestoformal/",
            CargarDocumentosPresupuesto: BASE_URL + "proyectos/presupuesto/cargardocumentospresupuesto/",
            export: BASE_URL + "proyectos/presupuesto/export/",
            costos: {
                list: BASE_URL + "proyectos/presupuesto/costos/",
            },
            asignar: BASE_URL + "proyectos/presupuesto/asignar/",
            cerrar: BASE_URL + "proyectos/presupuesto/cerrar/",
            cerrarUVT: BASE_URL + "proyectos/presupuesto/cerraruvt/",
            aceptar: BASE_URL + "proyectos/presupuesto/aceptar/",
            rechazar: BASE_URL + "proyectos/presupuesto/rechazar/",
            modificarplan: BASE_URL + "proyectos/presupuesto/modificarplan/",
            avanzar: BASE_URL + "proyectos/presupuesto/avanzar/",
            reporte: BASE_URL + "proyectos/presupuesto/reporte/",
            documento: BASE_URL + "proyectos/presupuesto/$id_presupuesto/documento/$id_archivo/",
            presupuestoformal: BASE_URL + "proyectos/presupuesto/$id_presupuesto/presupuestoformal/",
        },
        informes: {
            list: BASE_URL + "informes/cargainforme/list/",
            listhistoricos: BASE_URL + "informes/cargainforme/listhitoricos/",
            informe: BASE_URL + "informes/cargainforme/informe/",
            export: BASE_URL + "informes/cargainforme/export/",
            avanzar: BASE_URL + "informes/cargainforme/avanzar/",
            avanzarinformecliente: BASE_URL + "informes/cargainforme/avanzarinformecliente/",
            posponervencimiento: BASE_URL + "informes/posponervencimiento/",
        },
        cargainforme: {
            list: BASE_URL + "proyectos/cargainforme/list/",
            listhitoricos: BASE_URL + "proyectos/cargainforme/listhitoricos/",
            informe: BASE_URL + "proyectos/cargainforme/informe/",
            export: BASE_URL + "proyectos/cargainforme/export/",
            avanzar: BASE_URL + "proyectos/cargainforme/avanzar/",
        },
        cargadatos: {
            list: BASE_URL + "certificacion/cargadatos/list/",
            listhitoricos: BASE_URL + "certificacion/cargadatos/listhitoricos/",
            cargadatos: BASE_URL + "certificacion/cargadatos/cargadatos/",
            export: BASE_URL + "certificacion/cargadatos/export/",
            avanzar: BASE_URL + "certificacion/cargadatos/avanzar/",
            autorizar: BASE_URL + "certificacion/cargadatos/autorizar/",
            detail: BASE_URL + "certificacion/cargadatos/detail/",
            participacion: {
                list: BASE_URL + "certificacion/cargadatos/participacion/list/",
                export: BASE_URL + "certificacion/cargadatos/participacion/export/",
            },
            productividad: {
                list: BASE_URL + "cargadatos/productividad/list/",
                gestionList: BASE_URL + "cargadatos/productividad/gestionlist/",
                gestionListVisibilizar: BASE_URL + "cargadatos/gestionlist/detail/",
                diaVisibilidad: BASE_URL + "cargadatos/productividad/dia/",
                export: BASE_URL + "cargadatos/productividad/export/",
            },
            convenios: {
                list: BASE_URL + "cargadatos/convenios/list/",
                tipos:{
                    select: BASE_URL + "convenios/tipos/select/",
                    list: BASE_URL + "convenios/tipos/list/",
                    create: BASE_URL + "convenios/tipos/create/",
                    edit: BASE_URL + "convenios/tipos/edit/",
                    detail: BASE_URL + "convenios/tipos/detail/",
                    delete: BASE_URL + "convenios/tipos/delete/",
                },
                dependencias:{
                    select: BASE_URL + "convenios/dependencias/select/",
                    list: BASE_URL + "convenios/dependencias/list/",
                    create: BASE_URL + "convenios/dependencias/create/",
                    edit: BASE_URL + "convenios/dependencias/edit/",
                    detail: BASE_URL + "convenios/dependencias/detail/",
                    delete: BASE_URL + "convenios/dependencias/delete/",
                }
            }
        },
        enviodemails: {
            list: BASE_URL + "informes/enviodemails/list/",
            listhitoricos: BASE_URL + "informes/enviodemails/listhitoricos/",
            enviarmail: BASE_URL + "informes/enviodemails/enviarmail/",
            enviarmailuvt: BASE_URL + "informes/enviodemails/enviarmailuvt/",
            export: BASE_URL + "informes/enviodemails/export/",
        },
        config: {
            plantillas: {
                list: BASE_URL + "proyectos/config/plantillas/list/",
                select: BASE_URL + "proyectos/config/plantillas/select/",
                create: BASE_URL + "proyectos/config/plantillas/create/",
                edit: BASE_URL + "proyectos/config/plantillas/edit/",
                detail: BASE_URL + "proyectos/config/plantillas/detail/",
                delete: BASE_URL + "proyectos/config/plantillas/delete/",
                export: BASE_URL + "proyectos/config/plantillas/export/",
            },
            roles: {
                list: BASE_URL + "certificacion/config/roles/list/",
                select: BASE_URL + "certificacion/config/roles/select/",
                create: BASE_URL + "certificacion/config/roles/create/",
                edit: BASE_URL + "certificacion/config/roles/edit/",
                detail: BASE_URL + "certificacion/config/roles/detail/",
                delete: BASE_URL + "certificacion/config/roles/delete/",
                export: BASE_URL + "certificacion/config/roles/export/",
            },
            firmas: {
                list: BASE_URL + "certificacion/config/firmas/list/",
                select: BASE_URL + "certificacion/config/firmas/select/",
                create: BASE_URL + "certificacion/config/firmas/create/",
                edit: BASE_URL + "certificacion/config/firmas/edit/",
                detail: BASE_URL + "certificacion/config/firmas/detail/",
                delete: BASE_URL + "certificacion/config/firmas/delete/",
                export: BASE_URL + "certificacion/config/firmas/export/",
            },
            plan: {
                marcos: {
                    list: BASE_URL + "proyectos/config/plan/marcos/list/",
                    select: BASE_URL + "proyectos/config/plan/marcos/select/",
                    create: BASE_URL + "proyectos/config/plan/marcos/create/",
                    edit: BASE_URL + "proyectos/config/plan/marcos/edit/",
                    detail: BASE_URL + "proyectos/config/plan/marcos/detail/",
                    delete: BASE_URL + "proyectos/config/plan/marcos/delete/",
                    export: BASE_URL + "proyectos/config/plan/marcos/export/",
                },
                tipos: {
                    list: BASE_URL + "proyectos/config/plan/tipos/list/",
                    select: BASE_URL + "proyectos/config/plan/tipos/select/",
                    create: BASE_URL + "proyectos/config/plan/tipos/create/",
                    edit: BASE_URL + "proyectos/config/plan/tipos/edit/",
                    detail: BASE_URL + "proyectos/config/plan/tipos/detail/",
                    delete: BASE_URL + "proyectos/config/plan/tipos/delete/",
                    export: BASE_URL + "proyectos/config/plan/tipos/export/",
                },
                subtipos: {
                    list: BASE_URL + "proyectos/config/plan/subtipos/list/",
                    select: BASE_URL + "proyectos/config/plan/subtipos/select/",
                    create: BASE_URL + "proyectos/config/plan/subtipos/create/",
                    edit: BASE_URL + "proyectos/config/plan/subtipos/edit/",
                    detail: BASE_URL + "proyectos/config/plan/subtipos/detail/",
                    delete: BASE_URL + "proyectos/config/plan/subtipos/delete/",
                    export: BASE_URL + "proyectos/config/plan/subtipos/export/",
                },
                campos: {
                    list: BASE_URL + "proyectos/config/plan/campos/list/",
                    select: BASE_URL + "proyectos/config/plan/campos/select/",
                    create: BASE_URL + "proyectos/config/plan/campos/create/",
                    edit: BASE_URL + "proyectos/config/plan/campos/edit/",
                    detail: BASE_URL + "proyectos/config/plan/campos/detail/",
                    delete: BASE_URL + "proyectos/config/plan/campos/delete/",
                    ordenamiento: BASE_URL + "proyectos/config/plan/campos/ordenamiento/",
                    export: BASE_URL + "proyectos/config/plan/campos/export/",
                },
            },
            presupuesto: {
                coeficientesue: {
                    list: BASE_URL + "proyectos/config/presupuesto/coeficientesue/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/coeficientesue/select/",
                    create: BASE_URL + "proyectos/config/presupuesto/coeficientesue/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/coeficientesue/edit/",
                    activar: BASE_URL + "proyectos/config/presupuesto/coeficientesue/activar/",
                    detail: BASE_URL + "proyectos/config/presupuesto/coeficientesue/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/coeficientesue/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/coeficientesue/export/",
                },
                coeficientesgc: {
                    list: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/select/",
                    create: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/edit/",
                    activar: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/activar/",
                    detail: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/coeficientesgc/export/",
                },
                formula: {
                    calculate: BASE_URL + "proyectos/config/presupuesto/formula/calculate/",
                    edit: BASE_URL + "proyectos/config/presupuesto/formula/edit/",
                    detail: BASE_URL + "proyectos/config/presupuesto/formula/detail/",
                },
                condiciones: {
                    list: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/select/",
                    create: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/edit/",
                    detail: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/condicionesdepago/export/",
                },
                plazos: {
                    list: BASE_URL + "proyectos/config/presupuesto/plazos/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/plazos/select/",
                    create: BASE_URL + "proyectos/config/presupuesto/plazos/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/plazos/edit/",
                    detail: BASE_URL + "proyectos/config/presupuesto/plazos/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/plazos/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/plazos/export/",
                },
                tiposdecosto: {
                    list: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/select/",
                    treeselect: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/treeselect/",
                    create: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/edit/",
                    detail: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/tiposdecosto/export/",
                },
                motivos: {
                    list: BASE_URL + "proyectos/config/presupuesto/motivos/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/motivos/select/",
                    create: BASE_URL + "proyectos/config/presupuesto/motivos/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/motivos/edit/",
                    detail: BASE_URL + "proyectos/config/presupuesto/motivos/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/motivos/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/motivos/export/",
                },
                uvt: {
                    list: BASE_URL + "proyectos/config/presupuesto/uvt/list/",
                    select: BASE_URL + "proyectos/config/presupuesto/uvt/select/?tipo=0",
                    create: BASE_URL + "proyectos/config/presupuesto/uvt/create/",
                    edit: BASE_URL + "proyectos/config/presupuesto/uvt/edit/",
                    detail: BASE_URL + "proyectos/config/presupuesto/uvt/detail/",
                    delete: BASE_URL + "proyectos/config/presupuesto/uvt/delete/",
                    export: BASE_URL + "proyectos/config/presupuesto/uvt/export/",
                },
                ott: {
                    select: BASE_URL + "proyectos/config/presupuesto/uvt/select/?tipo=1",
                }
            }
        }
    },

    reportes: {
        visualizadorproyectos: BASE_URL + "reportes/visualizadorproyectos/",
    },

    email: {
        plantillas: {
            list: BASE_URL + "email/plantillas/list/",
            select: BASE_URL + "email/plantillas/select/",
            create: BASE_URL + "email/plantillas/create/",
            edit: BASE_URL + "email/plantillas/edit/",
            detail: BASE_URL + "email/plantillas/detail/",
            delete: BASE_URL + "email/plantillas/delete/",
            export: BASE_URL + "email/plantillas/export/",
        },
        casillas: {
            list: BASE_URL + "email/casillas/list/",
            select: BASE_URL + "email/casillas/select/",
            create: BASE_URL + "email/casillas/create/",
            edit: BASE_URL + "email/casillas/edit/",
            detail: BASE_URL + "email/casillas/detail/",
            delete: BASE_URL + "email/casillas/delete/",
            export: BASE_URL + "email/casillas/export/",
        },
    },
    configuracion: {
        edit: BASE_URL + "configuracion/edit/",
    },
    backup: {
        listdb: BASE_URL + "backup/db/list/",
        linkzip: BASE_URL + "backup/zip/link/",
    },
    imputaciones: {
        imputaciones: {
            list: BASE_URL + "imputaciones/imputaciones/list/",
            create: BASE_URL + "imputaciones/imputaciones/create/",
            edit: BASE_URL + "imputaciones/imputaciones/edit/",
            detail: BASE_URL + "imputaciones/imputaciones/detail/",
            delete: BASE_URL + "imputaciones/imputaciones/delete/",
            export: BASE_URL + "imputaciones/imputaciones/export/",

            distribuir: BASE_URL + "imputaciones/imputaciones/distribuir/",

            participacion: BASE_URL + "imputaciones/imputaciones/participacion/",
            notificarlt: BASE_URL + "imputaciones/imputaciones/notificarlt/",
            finalizar: BASE_URL + "imputaciones/imputaciones/finalizar/",
        },
        separacionImputaciones: {
            list: BASE_URL + "imputaciones/separacionimputaciones/list/",
            create: BASE_URL + "imputaciones/separacionimputaciones/create/",
            edit: BASE_URL + "imputaciones/separacionimputaciones/edit/",
            detail: BASE_URL + "imputaciones/separacionimputaciones/detail/",
            delete: BASE_URL + "imputaciones/separacionimputaciones/delete/",
            export: BASE_URL + "imputaciones/separacionimputaciones/export/",
        },
        titulosSeparaciones: {
            list: BASE_URL + "imputaciones/titulosseparaciones/list/",
            select: BASE_URL + "imputaciones/titulosseparaciones/select/",
            create: BASE_URL + "imputaciones/titulosseparaciones/create/",
            edit: BASE_URL + "imputaciones/titulosseparaciones/edit/",
            detail: BASE_URL + "imputaciones/titulosseparaciones/detail/",
            delete: BASE_URL + "imputaciones/titulosseparaciones/delete/",
            export: BASE_URL + "imputaciones/titulosseparaciones/export/",
        },
        reportes:{
            reportePDF: BASE_URL + "imputaciones/reporte/PDF/",
            reporteXLSX: BASE_URL + "imputaciones/reporte/XLSX/",
        }
    },
    convenios: {
        convenios: {
            list: BASE_URL + "convenios/convenios/list/",
            create: BASE_URL + "convenios/convenios/create/",
            detail: BASE_URL + "convenios/convenios/detail/",
            delete: BASE_URL + "convenios/convenios/delete/"
        }
    },
    tutoriales:{
        list: BASE_URL + "tutoriales/list/",
        select: BASE_URL + "tutoriales/select/",
        create: BASE_URL + "tutoriales/create/",
        edit: BASE_URL + "tutoriales/edit/",
        detail: BASE_URL + "tutoriales/detail/",
        delete: BASE_URL + "tutoriales/delete/",
        export: BASE_URL + "tutoriales/export/",
    },
}



// WEBPACK FOOTER //
// ./src/api/api.js